'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import toast from '@shared/utils/helpers/toast';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { PLATFORM_BRAND } from '../../utils/platformBrand';
import { client } from '../../utils/trpc';
import AppCard from './AppCard';
import { useOAuthReturn } from './useOAuthReturn';
type Props = {
  autoEnabled: boolean;
  issue?: boolean;
  onToggleAuto: () => void;
};
const YoutubeCard = t0 => {
  const $ = _c(13);
  const {
    autoEnabled,
    issue,
    onToggleAuto
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["youtubeHasToken"],
      queryFn: _temp,
      retry: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: status,
    isLoading
  } = useQuery(t1);
  let t2;
  if ($[1] !== queryClient) {
    t2 = async (code, state) => {
      const [error, data] = await client.platforms.youtube.connect.mutate({
        code,
        state
      });
      if (error) {
        toast(error.message || "Failed to connect YouTube");
        return;
      }
      toast(`YouTube connected as ${data?.channelTitle ?? "your channel"}`);
      await queryClient.invalidateQueries({
        queryKey: ["youtubeHasToken"]
      });
    };
    $[1] = queryClient;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useOAuthReturn("youtube", "YouTube", t2);
  const connect = _temp2;
  let t3;
  if ($[3] !== queryClient) {
    t3 = async () => {
      const [error_1] = await client.platforms.youtube.disconnect.mutate();
      if (error_1) {
        toast(error_1.message || "Failed to disconnect YouTube");
        return;
      }
      toast("YouTube account disconnected.");
      await queryClient.invalidateQueries({
        queryKey: ["youtubeHasToken"]
      });
    };
    $[3] = queryClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const disconnect = t3;
  const t4 = !!status?.hasToken;
  const t5 = status?.channelTitle ? `Connected to ${status.channelTitle}` : undefined;
  let t6;
  if ($[5] !== autoEnabled || $[6] !== disconnect || $[7] !== isLoading || $[8] !== issue || $[9] !== onToggleAuto || $[10] !== t4 || $[11] !== t5) {
    t6 = <AppCard label="YouTube" brand={PLATFORM_BRAND.YOUTUBE} loading={isLoading} connected={t4} accountText={t5} supports="Cross-posts videos" autoEnabled={autoEnabled} issue={issue} onConnect={connect} onDisconnect={disconnect} onToggleAuto={onToggleAuto} />;
    $[5] = autoEnabled;
    $[6] = disconnect;
    $[7] = isLoading;
    $[8] = issue;
    $[9] = onToggleAuto;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default YoutubeCard;
function _temp() {
  return unwrapFromResult(client.platforms.youtube.hasToken.query());
}
async function _temp2() {
  const [error_0, data_0] = await client.platforms.youtube.getAuthUrl.query();
  if (error_0 || !data_0?.url) {
    toast("Failed to start YouTube connection");
    return;
  }
  window.location.href = data_0.url;
}